export default __webpack_public_path__ + "static/media/whatsapp_logo.06742f3e.svg";